export default __webpack_public_path__ + "static/media/jedzcochcesz.92f525d9.svg";